/**
 * Created by Ivan on 06.06.2025
 */

const BubblesStack = function (slot) {
    cleverapps.EventEmitter.call(this);

    this.slot = slot;
    this.stack = [];

    this.customIcon = BubblesStackView;
    this.extraBarWeight = 100006;

    this.load();

    this.onGetView = function () {};
};

BubblesStack.prototype = Object.create(cleverapps.EventEmitter.prototype);
BubblesStack.prototype.constructor = BubblesStack;

BubblesStack.prototype.load = function () {
    const stackInfo = this.slot.load("bubblesstack") || "";
    for (let index = 0; index + 3 <= stackInfo.length; index += 3) {
        const unit = Families.processUnknown(FlatMapSaver.expandUnit(stackInfo.substring(index, index + 3)), Merge2.current.families);
        this.stack.push(unit);
        cleverapps.unitsLibrary.openUnit(unit);
    }
};

BubblesStack.prototype.top = function () {
    return this.stack[this.stack.length - 1];
};

BubblesStack.prototype.push = function (unit, silent) {
    this.stack.push(unit);
    cleverapps.unitsLibrary.openUnit(unit);
    this.trigger("changeUnit", unit);
    this.save();
    if (!silent) {
        this.onPush();
    }
};

BubblesStack.prototype.moveTop = function (unit) {
    const index = this.stack.findIndex((item) => Unit.Equals(unit, item));
    if (index !== this.stack.length - 1) {
        const [item] = this.stack.splice(index, 1);
        this.stack.push(item);
        this.trigger("onChangeUnit");
    }
};

BubblesStack.prototype.isVisible = function () {
    return this.top();
};

BubblesStack.prototype.onPush = function () {
    this.trigger("onChangeUnit");
    this.trigger("updateVisible");
    cleverapps.tutorial.trigger("onPushBubbleStack");
};

BubblesStack.prototype.getUnits = function () {
    return cleverapps.clone(this.stack, true);
};

BubblesStack.prototype.save = function () {
    this.slot.save("bubblesstack", this.stack.map((unit) => FlatMapSaver.compactUnit(unit.code === "unknown" ? unit._data : unit)).join(""));
};

BubblesStack.prototype.isEmpty = function () {
    return this.size() === 0;
};

BubblesStack.prototype.size = function () {
    return this.stack.length;
};

BubblesStack.prototype.pop = function (sourceNode) {
    if (this.isEmpty()) {
        return;
    }

    const remains = Merge2.current.spawn(this.top(), sourceNode, { fromNode: true });
    if (remains.length) {
        cleverapps.tutorial.trigger("onPopBubbleStack");
        return;
    }

    const unit = this.stack.pop();
    this.trigger("changeUnit", unit);
    this.trigger("onChangeUnit");
    this.trigger("updateVisible");
    cleverapps.tutorial.trigger("onPopBubbleStack", unit);

    this.save();

    return unit;
};

BubblesStack.prototype.removeByCode = function (code) {
    this.stack = this.stack.filter((unit) => unit.code !== code);
};

BubblesStack.prototype.onSpawned = function (source, units, delay) {
    units.forEach((unit, index) => {
        new ActionPlayer([
            (f) => {
                cleverapps.timeouts.setTimeout(f, delay + 300 * index);
            },
            (f) => {
                this.trigger("spawn", source, unit);
                cleverapps.timeouts.setTimeout(f, 300);
            },
            (f) => {
                this.push(unit);
                f();
            }
        ]).play();
    });
};

BubblesStack.ID = "bubbles_stack";